import { useRouter } from 'next/router';
import { useState } from 'react';

import useAnalyticEvent, { PageName } from '../../../hooks/useAnalyticEvent';
import { APP_BASE_PATH } from '../../../shared/appBasePath';
import { buildNavigationUrl } from '../../../shared/routes';
import PlateVinEntry from './PlateVinEntry/PlateVinEntry';

const wizardRoute = `${APP_BASE_PATH}/get-value/vehicle`;

type SubmitPlateVin = { vin: string } | { plate: string; plateState: string };
enum SubmissionType {
  Vin = 'Vin',
  PlateState = 'Plate/State'
}

const VehicleEntryContainer = () => {
  const router = useRouter();
  const { recordEventAndNavigateTo } = useAnalyticEvent();
  const [isLoading, setIsLoading] = useState(false);
  const submitText = 'Get Your Value';

  const handleRedirect = (submitData: Record<string, string>, redirectUrl: string) => {
    const submissionType = 'vin' in submitData ? SubmissionType.Vin : SubmissionType.PlateState;

    recordEventAndNavigateTo(
      redirectUrl,
      PageName.Marketing,
      `Track My Value Hero - ${submissionType} submission`,
      submitData
    );
  };

  const submitPlateVin = (info: SubmitPlateVin) => {
    setIsLoading(true);
    const sendToWizard: { vin: string } | { licensePlate: string; plateState: string } =
      'vin' in info ? { vin: info.vin } : { licensePlate: info.plate, plateState: info.plateState };

    const redirectUrl = buildNavigationUrl(wizardRoute, sendToWizard);
    handleRedirect(sendToWizard, redirectUrl);
  };

  const queryParams = router?.query;

  return (
    <PlateVinEntry
      submitPlateVin={submitPlateVin}
      submitText={submitText}
      queryParams={queryParams}
      isLoading={isLoading}
    />
  );
};

export default VehicleEntryContainer;
